// terms.selectors.ts
import { useTermsStore } from "./terms.store";

export const useTermsType = () => useTermsStore((s) => s.termsType);
export const useTermsStatus = () => useTermsStore((s) => s.termsStatus);
export const useTermsCode = () => useTermsStore((s) => s.termsCode); // ✅ 추가

export const useTermsApplyStrDatetime = () => useTermsStore((s) => s.applyStrDatetime);
export const useTermsApplyEndDatetime = () => useTermsStore((s) => s.applyEndDatetime);
export const useTermsPage = () => useTermsStore((s) => s.page);
export const useTermsSize = () => useTermsStore((s) => s.size);
export const useTermsOrder = () => useTermsStore((s) => s.order);
export const useTermsSearchTick = () => useTermsStore((s) => s._searchTick);

export const useSetTermsQuery = () => useTermsStore((s) => s.setQuery);
export const useResetTermsQuery = () => useTermsStore((s) => s.reset);
export const useTriggerTermsSearch = () => useTermsStore((s) => s.triggerSearch);

export * from "./terms.store";
